import { render } from "./AssessmentParts.vue?vue&type=template&id=7a40fefd&scoped=true"
import script from "./AssessmentParts.vue?vue&type=script&lang=js"
export * from "./AssessmentParts.vue?vue&type=script&lang=js"

import "./AssessmentParts.vue?vue&type=style&index=0&id=7a40fefd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a40fefd"]])

export default __exports__